var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-white"},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }